import { Link, Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeviceType } from "@hook/useDeviceType";
import { useNavigation } from "../hook/useNavigation";
import { useStyle } from "../style";
import { ILink } from "../hook/useNavigationLinks";

interface INavigationLinkDesktopProps {
    link: ILink;
}

export const NavigationLinkDesktop = (props: INavigationLinkDesktopProps) => {
    const { link } = props;
    const { isDesktop } = useDeviceType();
    const { t } = useTranslation("header");
    const { isRouteActive } = useNavigation();
    const isActive = isRouteActive(link.route);
    const { classes } = useStyle({ isDesktop, isActive });

    return (
        <div className={classes.navLinkContainer}>
            <Link className={classes.navLink} href={link.route} id={link.id} underline="none">
                <Typography className={classes.navLinkText} variant="large">
                    <span className={classes.navLinkLabel}>{link.title}</span>
                    {link.showNewBadge && (
                        <Box className={classes.newBadge} component="span">
                            {t("new")}
                        </Box>
                    )}
                </Typography>
            </Link>
        </div>
    );
};
